let modalidades = [
    {
        modalidade: "Iniciação Profissional Presencial",
        cr: "30303010101"
    },
    {
        modalidade: "Iniciação Profissional à Distância",
        cr: "30303010201"
    },
    {
        modalidade: "Qualificação Profissional Presencial",
        cr: "30303020201"
    },
    {
        modalidade: "Qualificação Profissional a Distância",
        cr: "30303020401"
    },
    {
        modalidade: "Qualificação Profissional - Itinerário V Ensino Médio",
        cr: "30303020401"
    },
    {
        modalidade: "Aperfeiçoamento/Espec.Profiss.Presencial",
        cr: "30303020501"
    },
    {
        modalidade: "Aperfeiçoamento/Espec.Profis.a Distância",
        cr: "30303020601"
    },
    {
        modalidade: "Técnico de Nível Médio Presencial",
        cr: "30303040201"
    },
    {
        modalidade: "Técnico de Nível Médio a Distância",
        cr: "30303040401"
    },
    {
        modalidade: "Técnico N.Médio Presencial Itinerário V",
        cr: "30303040501"
    },
    {
        modalidade: "Aprendizagem Industrial Presencial",
        cr: "30303020101"
    },
    {
        modalidade: "Aprendizagem Industrial a Distância",
        cr: "30303020301"
    },
    {
        modalidade: "Graduação Tecnológica Presencial",
        cr: "30304010101"
    },
    {
        modalidade: 'Pós-Graduação "lato sensu" - Especializa',
        cr: "30304010301"
    },
    {
        modalidade: "Cursos de Extensão Presencial",
        cr: "30304010601"
    },
    {
        modalidade: "Cursos de Extensão a Distância",
        cr: "30304010601"
    },
    {
        modalidade: "Aprendizagem Industrial Técnica Presenc.",
        cr: "30303040101"
    },
]

const { parseUnidadeSigla } = require("../../../../constants/unidades");

module.exports = {
    modalidades,
    parseUnidadeSigla
}